import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { toast } from 'sonner';
import api from '../utils/api';
import { Mail, ArrowLeft } from 'lucide-react';
import BrandLogo from '../components/BrandLogo';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await api.post('/auth/forgot-password', { email });
            setSent(true);
            toast.success('If that email exists, a reset link has been sent');
        } catch (error) {
            // Still show success to not reveal if email exists
            setSent(true);
            toast.success('If that email exists, a reset link has been sent');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="flex flex-col items-center mb-6">
                <BrandLogo className="h-16 w-16 rounded-lg shadow-lg" />
                <h1 className="mt-4 text-2xl font-bold text-white">Reset Password</h1>
                <p className="mt-2 text-sm text-slate-300">Enter your email to receive a reset link</p>
            </div>

            <Card className="border border-white/10 bg-white/5 backdrop-blur-md shadow-xl">
                <CardContent className="pt-6">
                    {sent ? (
                        <div className="text-center py-4">
                            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-500/20 flex items-center justify-center">
                                <Mail className="h-8 w-8 text-green-400" />
                            </div>
                            <h3 className="text-lg font-medium text-white mb-2">Check your email</h3>
                            <p className="text-slate-400 mb-4">
                                If an account exists for {email}, you'll receive a password reset link.
                            </p>
                            <Link to="/login">
                                <Button variant="outline" className="border-slate-600 text-white hover:bg-white/10">
                                    <ArrowLeft className="mr-2 h-4 w-4" />
                                    Back to Login
                                </Button>
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div className="space-y-2">
                                <Label htmlFor="email" className="text-slate-200">Email</Label>
                                <div className="relative">
                                    <Mail className="absolute left-3 top-3 h-4 w-4 text-slate-400" />
                                    <Input
                                        id="email"
                                        type="email"
                                        placeholder="you@example.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="pl-10 bg-white/5 border-slate-600 text-white placeholder:text-slate-400"
                                        required
                                    />
                                </div>
                            </div>

                            <Button
                                type="submit"
                                className="w-full bg-gradient-to-r from-[#9b00e8] to-[#ff4500] hover:from-[#8800d4] hover:to-[#e63e00]"
                                disabled={loading}
                            >
                                {loading ? 'Sending...' : 'Send Reset Link'}
                            </Button>

                            <p className="text-center text-sm text-slate-400">
                                Remember your password?{' '}
                                <Link to="/login" className="font-medium text-white hover:underline">
                                    Sign in
                                </Link>
                            </p>
                        </form>
                    )}
                </CardContent>
            </Card>
        </>
    );
};

export default ForgotPassword;
